<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="rolesUpdated($event)">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Contests List|Contests List title@@contests-list-title">Contests</h1>

        <div class="fill-space"></div>

        <app-button *ngIf="editAllowed"
                    label="Create Contest"
                    i18n-label="Contests List|Create Contest button title@@contests-list-create-button-title"
                    color="primary"
                    (clicked)="createContest()"></app-button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <app-no-content *ngIf="contests && !contests.length"
                      [compact]="true"
                      title="You don't have any contests yet"
                      i18n-title="Contests List|No contests title@@contests-list-no-items-title"
                      details="Start with creating a new contest"
                      i18n-details="Contests List|No contests details@@contests-list-no-items-details">

        <app-button label="Create Contest"
                    i18n-label="Contests List|Create Contest button title@@contests-list-create-button-title"
                    color="primary"
                    class="center create-cta"
                    (clicked)="createContest()"></app-button>
      </app-no-content>

      <mat-spinner *ngIf="!contests" color="primary" diameter="50" class="center"></mat-spinner>

      <contests-list *ngIf="competitionId && contests"
                     [contests]="contests"
                     [competitionId]="competitionId"
                     [editAllowed]="true"
                     [deleteAllowed]="true"
                     (listUpdated)="loadContests($event)"></contests-list>
    </div>
  </div>
</permission-checker>
